module.exports = __webpack_public_path__ + "img/RedBullBrand.cc38dba2.svg";